module.exports = __webpack_public_path__ + "static/media/instagram.3eb0f9a4.png";